/**
 * Сокращение длинных подписей для виджетов и списков.
 *
 * Названия поисковых источников строятся из текста запроса и доходят до
 * двух сотен символов. В чипе, легенде и на оси такая подпись ломает вид
 * виджета, поэтому выводим начало, а полное название отдаём в подсказку.
 */

/** Длина подписи по умолчанию: столько же занимает имя телеграм-канала. */
export const LABEL_LIMIT = 40;

/** Начало строки с многоточием; короткие строки возвращаются без изменений. */
export function truncate(value, limit = LABEL_LIMIT) {
  const text = (value == null ? '' : String(value)).trim();
  if (text.length <= limit) return text;
  return `${text.slice(0, limit - 1).trimEnd()}…`;
}

/**
 * Пометки форматирования сообщений (парсер Telegram оборачивает жирный текст в **…**)
 * без самих пометок: для коротких превью без разметки. Полный текст сообщения
 * переводит их в теги (MessagesModal.formatMessageText).
 */
export function stripInlineMarkup(value) {
  return (value == null ? '' : String(value))
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/`([^`]+)`/g, '$1');
}

export default truncate;
